<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><a id="page_v"><em>Contents</em></a></h1><a id="page_v">
</a><p class="toc-fm"><a id="page_v"></a><a href="#/006_Preface#fm-1"><span class="smallcaps">PREFACE</span></a></p>
<p class="toc-fm"><a href="#/007_Consulting_Editors#fm-2"><span class="smallcaps">CONSULTING</span> <span class="smallcaps">EDITORS</span></a></p>
<p class="toc-fm"><a href="#/008_Contributors#fm-3"><span class="smallcaps">CONTRIBUTORS</span></a></p>
<p class="toc-fm"><a href="#/009_Alphabetical_List#fm-4"><span class="smallcaps">ALPHABETICAL</span> <span class="smallcaps">LIST OF</span> <span class="smallcaps">ENTRIES</span></a></p>
<p class="toc-fm"><a href="#/010_Topical_List#fm-5"><span class="smallcaps">TOPICAL</span> <span class="smallcaps">LIST OF</span> <span class="smallcaps">ENTRIES</span></a></p>
<p class="toc-fm"><a href="#/011_Map_List#fm-6"><span class="smallcaps">LIST OF</span> <span class="smallcaps">MAPS</span></a></p>
<p class="toc-fm"><a href="#/012_Chronology#fm-7"><span class="smallcaps">CHRONOLOGY</span></a></p>
<p class="toc-fm"><a href="#/013_Abbreviations#fm-8"><span class="smallcaps">ABBREVIATIONS</span></a></p>
<p class="toc-parta"><strong>ESSAYS</strong></p>
<p class="toc-chap"><a href="#/014_Chapter01#ch-1">Early Judaism in Modern Scholarship</a></p>
<p class="toc-chapa"><a href="#/014_Chapter01#ch-1"><em>John J. Collins</em></a></p>
<p class="toc-chap"><a href="#/015_Chapter02#ch-2">Jewish History from Alexander to Hadrian</a></p>
<p class="toc-chapa"><a href="#/015_Chapter02#ch-2"><em>Chris Seeman and Adam Kolman Marshak</em></a></p>
<p class="toc-chap"><a href="#/016_Chapter03#ch-3">Judaism in the Land of Israel</a></p>
<p class="toc-chapa"><a href="#/016_Chapter03#ch-3"><em>James C. VanderKam</em></a></p>
<p class="toc-chap"><a href="#/017_Chapter04#ch-4">Judaism in the Diaspora</a></p>
<p class="toc-chapa"><a href="#/017_Chapter04#ch-4"><em>Erich S. Gruen</em></a></p>
<p class="toc-chap"><a href="#/018_Chapter05#ch-5">The Jewish Scriptures: Texts, Versions, Canons</a></p>
<p class="toc-chapa"><a href="#/018_Chapter05#ch-5"><em>Eugene Ulrich</em></a></p>
<p class="toc-chap"><a href="#/019_Chapter06#ch-6">Early Jewish Biblical Interpretation</a></p>
<p class="toc-chapa"><a href="#/019_Chapter06#ch-6"><em>James L. Kugel</em></a></p>
<p class="toc-chap"><a href="#/020_Chapter07#ch-7">Apocrypha and Pseudepigrapha</a></p>
<p class="toc-chapa"><a href="#/020_Chapter07#ch-7"><em>Loren T. Stuckenbruck</em></a></p>
<p class="toc-chap"><a href="#/021_Chapter08#ch-8">Dead Sea Scrolls</a></p>
<p class="toc-chapa"><a href="#/021_Chapter08#ch-8"><em>Eibert Tigchelaar</em></a></p>
<p class="toc-chap"><a href="#/022_Chapter09#ch-9">Early Jewish Literature Written in Greek</a></p>
<p class="toc-chapa"><a href="#/022_Chapter09#ch-9"><em>Katell Berthelot</em></a></p>
<p class="toc-chap"><span href="#/023_Chapter10#ch-10" title="Link target outside of Sample">Archaeology, Papyri, and Inscriptions</span></p>
<p class="toc-chapa"><span href="#/023_Chapter10#ch-10" title="Link target outside of Sample"><em>Jürgen K. Zangenberg</em></span></p>
<p class="toc-chap"><span href="#/024_Chapter11#ch-11" title="Link target outside of Sample">Jews among Greeks and Romans</span></p>
<p class="toc-chapa"><span href="#/024_Chapter11#ch-11" title="Link target outside of Sample"><em>Miriam Pucci Ben Zeev</em></span></p>
<p class="toc-chap"><span href="#/025_Chapter12#ch-12" title="Link target outside of Sample">Early Judaism and Early Christianity</span></p>
<p class="toc-chapa"><span href="#/025_Chapter12#ch-12" title="Link target outside of Sample"><em>Daniel C. Harlow</em></span></p>
<p class="toc-chap"><span href="#/026_Chapter13#ch-13" title="Link target outside of Sample">Early Judaism and Rabbinic Judaism</span></p>
<p class="toc-chapa"><span href="#/026_Chapter13#ch-13" title="Link target outside of Sample"><em>Lawrence H. Schiffman</em></span></p>
<p class="toc-parta"><span href="#/027_BM01#bm-1" title="Link target outside of Sample"><strong>DICTIONARY ENTRIES A-Z</strong></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_Contents.vue?6363b36c